import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 15a6 6 0 1 1 -12 0v-6a6 6 0 1 1 12 0v2","key":"svg-0"}],["path",{"d":"M15 8l3 3l3 -3","key":"svg-1"}]]

/**
 * IconArrowCapsule
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctY2Fwc3VsZSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTggMTVhNiA2IDAgMSAxIC0xMiAwdi02YTYgNiAwIDEgMSAxMiAwdjIiIC8+CiAgPHBhdGggZD0iTTE1IDhsMyAzbDMgLTMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrow-capsule
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowCapsule = createReactComponent('outline', 'arrow-capsule', 'ArrowCapsule', __iconNode);

export default IconArrowCapsule;